import { StrictMode } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from '@/contexts/auth0Provider/AuthContext';

import App from './App';
import ToastContextProvider from './components/Toast/ToastContextProvider';
import customTheme from './themes/muiTheme';

export function renderStandaloneApp(rootElement: HTMLElement, licenseKey?: string) {
  if (licenseKey && licenseKey.trim() !== '') {
    LicenseInfo.setLicenseKey(licenseKey);
  }

  createRoot(rootElement).render(
    <StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider theme={customTheme}>
            <ToastContextProvider>
              <App env="standalone" />
            </ToastContextProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </StrictMode>,
  );
}